import React from 'react';

/* eslint-disable prefer-destructuring */
import { toSlug } from '@/utils/common';
import { pr } from '@/utils/pxToRem';
import { Stack, Link } from '@mui/material';
import AIRPORT_VN from '@/mappings/airport_vn.json';
import { genLinkSeo } from '@/utils/genLinkSeo';

interface SectionFamousPlaceProps {
  startPoint: any;
  company: string;
  isDesktop?: boolean;
}

const SectionFamousPlace: React.FC<SectionFamousPlaceProps> = ({
  startPoint, company, isDesktop,
}) => {
  const key = startPoint?.airports[0]?.airportCode;
  const listRoute = (AIRPORT_VN as any).routes[key];
  if (listRoute?.length > 10) {
    listRoute.length = 10;
  }
  return (
    <Stack
      spacing="16px"
      sx={isDesktop ? {
        maxHeight: '180px',
        flexWrap: 'wrap',
      } : {}}
      marginTop={pr`16px`}
    >
      {listRoute.map((airpotCode: string, index: number) => {
        const areaData = AIRPORT_VN.airports.find((item) => item.AirportCode === airpotCode);
        return (
          <Link
            sx={{
              fontWeight: 500,
              textDecoration: 'none',
              marginTop: index === 0 ? '16px' : 0,
            }}
            href={genLinkSeo({
              company,
              endName: areaData?.CityName_Vi,
              endId: areaData?.VxrAreaParentId,
              endStateName: areaData?.stateName,
            })}
            key={airpotCode}
          >
            {` Vé máy bay ${company} giá rẻ 
            đi 
            ${areaData?.CityName_Vi}
            `}
          </Link>
        );
      })}
    </Stack>
  );
};

const SectionCompanyFamousPlace = (props: any) => {
  const startPoint = {
    id: '29',
    location: 'Sài Gòn',
    country: 'Việt Nam',
    highlight: '',
    airports: [
      {
        id: '28284',
        nameVn: 'Sân bay Tân Sơn Nhất',
        nameEn: 'Tan Son Nhat International Airport',
        distance: '8.67314724377464',
        airportCode: 'SGN',
        highlight: 'Sân bay Tân Sơn Nhất',
      },
    ],
  };
  return (
    <SectionFamousPlace
      {...props}
      startPoint={startPoint}
    />
  );
};

export default SectionCompanyFamousPlace;
